const RightArrowForCartPage2 = () => {
  function ProductsHandler() {}

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="CartRightArrowIcon"
      onClick={ProductsHandler}
      id="CartRightArrowIconId"
      style={{ width: "24px", height: "24px" }}
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <line
        x1="40"
        y1="128"
        x2="216"
        y2="128"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <polyline
        points="144 56 216 128 144 200"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
    </svg>
  );
};

export default RightArrowForCartPage2;
